<div class="body-container">
    <div>
        {{ 'version.create.dialog.trial.text' | translate }}
    </div>
    <div class="options-container">
        <div
            class="option"
            data-cy="version-new-version-trial-yes-option"
            [ngClass]="{ selected: isTrialRun }"
            (click)="handleOptionSelected(true)">
            <mat-icon svgIcon="check" class="icon" />
            <div>{{ 'version.create.dialog.trial.yes' | translate }}</div>
        </div>
        <div
            class="option"
            data-cy="version-new-version-trial-no-option"
            [ngClass]="{ selected: isTrialRun === false }"
            (click)="handleOptionSelected(false)">
            <mat-icon svgIcon="close" class="icon" />
            <div>{{ 'version.create.dialog.trial.no' | translate }}</div>
        </div>
    </div>
</div>
